const travelFilterConfig = {
  travelFilter: {
    inputs: {
      destinations: {
        enabled: true,
      },
      months: {
        enabled: true,
      },
      travelTypes: {
        enabled: true,
      },
      query: {
        enabled: true,
      },
    },
  },
}

export default travelFilterConfig
